import { Injectable, inject } from '@angular/core';
import { AppConfig } from '../app-config';
import { APP_CONFIG } from '../app-config.token';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class EmployerService {
  private http = inject(HttpClient);
  private config = inject<AppConfig>(APP_CONFIG);

  private readonly API_URL = this.config.resourceApiURI + '/employers';

  constructor() {}

  hasAccessToRecruiter(employerId: number): Observable<boolean> {
    const url = `${this.API_URL}/${employerId}/hasAccessToRecruiter`;

    return this.http.get<boolean>(url);
  }
}
